module.exports = __webpack_public_path__ + "img/read-aloud-white.defa420b.svg";